export default __webpack_public_path__ + "static/media/tree_4_unlocked.a848a9a4.png";